import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createDaycare, createModules, fetchDaycare, fetchDaycareById, fetchModules, removeDaycare, removeModules, updateDaycare, updateDaycareStatus, updateModules } from "../../service/api";


export const getDaycare = createAsyncThunk(
    "daycare/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchDaycare(params)
            console.log("fetch module", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)

        }
    }
)

export const getDaycareById = createAsyncThunk(
    "daycare/daycareById",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchDaycareById(params)
            console.log("daycre by id", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const addDaycare = createAsyncThunk(
    "daycare/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createDaycare(formValue)
            if (response.status === 201) {
                console.log("response", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

export const editDaycare = createAsyncThunk(
    "daycare/edit",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateDaycare(newData)
            if (response.status === 201) {
                console.log("edit modules", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)



export const editDaycareStatus = createAsyncThunk(
    "daycare/editStatus",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateDaycareStatus(newData)
            if (response.status === 201) {
                console.log("edit status", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)

export const deleteDaycare = createAsyncThunk(
    "daycare/delete",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await removeDaycare(newData)
            if (response.status === 201) {
                console.log("edit modules", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)



const daycareSlice = createSlice({
    name: "daycare",
    initialState: {
        daycareList: [],
        daycareById: {},
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        date: null,
        limit: 10,
        searchParams: ""
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
        setDateKeyFilter: (state, action) => {
            state.date = action.payload
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getDaycare.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getDaycare.fulfilled, (state, action) => {
                state.isLoading = false;
                state.daycareList = action.payload.data;
                state.totalPage = action.payload.totalPage
            })
            .addCase(getDaycare.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //by id

            .addCase(getDaycareById.pending, (state) => {
                state.error = null;
                state.isLoading = true

            })
            .addCase(getDaycareById.fulfilled, (state, action) => {
                state.daycareById = action.payload.data;
                state.isLoading = false


            })
            .addCase(getDaycareById.rejected, (state, action) => {
                state.error = action.payload;
                state.isLoading = false

            })


            // POST

            .addCase(addDaycare.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addDaycare.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addDaycare.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT
            .addCase(editDaycare.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editDaycare.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editDaycare.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // PUT STATUS
            .addCase(editDaycareStatus.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editDaycareStatus.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editDaycareStatus.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // delete
            .addCase(deleteDaycare.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(deleteDaycare.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(deleteDaycare.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})

export const { setSearchParams, setPagination, setDateKeyFilter } = daycareSlice.actions;

export default daycareSlice.reducer;